var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TransportationBatch',{attrs:{"idx":_vm.idx}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }